import { useState, type MouseEvent as ReactMouseEvent } from 'react'
import { PictureInPicture2 } from 'lucide-react'
import type { Track } from 'livekit-client'
import { streamLabel } from '@/lib/streamView'
import { canPopOut, closePopOut, popOutStream, usePoppedOut, type PopKind } from './streamPip'
import styles from './VoiceRoom.module.css'

/**
 * «Вынести в окно» на плитке с видео: камера собеседника (или экран в звонке) поверх других окон,
 * как у развёрнутой трансляции. Окно одно: новое закрывает прежнее. Отказ браузера — подсказкой
 * на плитке на четыре секунды, иначе кнопка выглядела бы так, будто ничего не делает.
 */
export function TilePip({ kind, userId, track, name }: { kind: PopKind; userId: string; track: Track; name: string }) {
  const popped = usePoppedOut(kind) === userId
  const [error, setError] = useState<string | null>(null)
  if (!canPopOut) return null

  const toggle = (e: ReactMouseEvent<HTMLButtonElement>) => {
    if (popped) {
      closePopOut()
      return
    }
    const video = e.currentTarget.closest('[data-user-id]')?.querySelector('video')
    const aspect = video && video.videoHeight ? video.videoWidth / video.videoHeight : undefined
    const fail = (text: string) => {
      setError(text)
      setTimeout(() => setError(null), 4000)
    }
    setError(null)
    popOutStream(userId, track, kind === 'camera' ? `Камера ${name}` : streamLabel(name), aspect, kind)
      .then((result) => {
        if (result === 'retry') fail('Окно поверх не открылось. Нажмите ещё раз')
      })
      .catch((err: unknown) => {
        if (err instanceof Error) console.warn('окно поверх не открылось:', err.message)
        fail('Окно поверх не открылось')
      })
  }

  return (
    <>
      <button type="button" className={styles.tilePip} data-tooltip={popped ? 'Вернуть из окна' : 'Вынести в окно'} aria-label={popped ? 'Вернуть из окна' : 'Вынести в окно'} aria-pressed={popped} onClick={toggle}>
        <PictureInPicture2 size={16} />
      </button>
      {error ? <span className={styles.tilePipError} role="status">{error}</span> : null}
    </>
  )
}
